import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './pages/components/ProtectedRoutes';
import AuthCallback from './pages/AuthCallback';
import Home from './pages/home';
import Bienvenida from './pages/components/Bienvenida';
import Catalogos from './pages/components/Catalogos';
import VentasAutorizadas from './pages/components/VentasAutorizadas';
import Usuarios from './pages/components/catalogo/Usuarios';
import Motivos from './pages/components/catalogo/Motivos';
import Segmentos from './pages/components/catalogo/Segmentos';
import PorcentajesAutorizacion from './pages/components/catalogo/PorcentajesAutorizacion';
import Configuracion from './pages/components/Configuracion';
import ReglasDescuento from './pages/components/ReglasDescuento';
import { AuthProvider } from "./_auth/AuthContext";
import PermisosPerfil from './pages/components/PermisosPerfil';
//import RoutesApp from "./RoutesApp";

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>}>
          <Route index element={<Bienvenida />} />
          <Route path="saldo" element={<PermisosPerfil perfilesPermitidos={[1,2,3]}><VentasAutorizadas /></PermisosPerfil>} />
          <Route path="cat" element={<PermisosPerfil perfilesPermitidos={[1,2]}><Catalogos /></PermisosPerfil>} />
          <Route path="motivos" element={<PermisosPerfil perfilesPermitidos={[1,2]}><Motivos /></PermisosPerfil>} />
          <Route path="segmentos" element={<PermisosPerfil perfilesPermitidos={[1,2]}><Segmentos /></PermisosPerfil>} />
          <Route path="usuarios" element={<PermisosPerfil perfilesPermitidos={[1,2]}><Usuarios /></PermisosPerfil>} />
          <Route path="porcentajes" element={<PermisosPerfil perfilesPermitidos={[1,2]}><PorcentajesAutorizacion /></PermisosPerfil>} />
          <Route path="configuracion" element={<PermisosPerfil perfilesPermitidos={[1,2]}><Configuracion /></PermisosPerfil>} />
          <Route path="reglas" element={<PermisosPerfil perfilesPermitidos={[1]}><ReglasDescuento /></PermisosPerfil>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;